import {defineSlotRecipe} from '@chakra-ui/react3'

export const collapsibleSlotRecipe = defineSlotRecipe({
    slots: ['root', 'trigger', 'content', 'indicator'],
    className: 'chakra-collapsible',
    base: {
        content: {
            overflow: 'hidden',
            _open: {
                animationName: 'expand-height, fade-in',
                animationDuration: 'moderate'
            },
            _closed: {
                animationName: 'collapse-height, fade-out',
                animationDuration: 'moderate'
            }
        }
    }
})
